@for (notification of notificationService.notifications; track notification) {
<ngb-toast class="text-light fw-bold" [class.bg-success1]="notification.isSuccess" [class.bg-info]="notification.isInfo"
    [class.bg-danger]="notification.isDanger" [class.bg-warning]="notification.isWarning" [autohide]="true"
    [delay]="notification.delay || 5000" (hidden)="toastService?.remove(notification)" [header]="notification.title">
    {{notification.body}}
</ngb-toast>
}